<!-- One card design for both hosts: the 2FA gate (compact, the two methods) and Settings (the two methods plus
     recovery codes). Header: title and state. Body: one sentence. Footer: the action. `fill` keeps a row's cards
     the same height. -->
<ph-columns [min]="compact ? '280px' : '260px'">
    <ng-container *ngTemplateOutlet="googleCard"></ng-container>
    <ng-container *ngTemplateOutlet="smsCard"></ng-container>
    <ng-container *ngIf="!compact">
        <ng-container *ngTemplateOutlet="recoveryCard"></ng-container>
    </ng-container>
</ph-columns>

<ng-template #googleCard>
    <ph-card heading="Authenticator app" fill [tone]="highlight2fa && !isGoogleAuthEnabled ? 'warning' : 'none'">
        <ph-badge *ngIf="!isLoading && highlight2fa && !isGoogleAuthEnabled" slot="title-actions" variant="light" color="orange">Recommended</ph-badge>
        <ph-status-badge *ngIf="!isLoading && !(highlight2fa && !isGoogleAuthEnabled)"
                         slot="title-actions"
                         variant="light"
                         [status]="isGoogleAuthEnabled ? 'completed' : 'disabled'">{{ isGoogleAuthEnabled ? 'Enabled' : 'Not set up' }}</ph-status-badge>

        <ph-skeleton *ngIf="isLoading" lines="2" label="Loading authenticator app"></ph-skeleton>
        <ng-container *ngIf="!isLoading">
            <div *ngIf="isGoogleAuthEnabled">Enter the 6-digit code your authenticator app shows when you sign in.</div>
            <div *ngIf="!isGoogleAuthEnabled">
                Sign-in codes from an app on your phone, with no text message needed. No app yet? Try Google Authenticator for
                <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank" rel="nofollow noopener">iOS</a> or
                <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US" target="_blank" rel="nofollow noopener">Android</a>.
            </div>
        </ng-container>

        <ph-actions slot="footer" *ngIf="!isLoading">
            <ph-button *ngIf="isGoogleAuthEnabled" variant="secondary" mode="filled" (click)="disableGoogleAuth()">Disable authenticator app</ph-button>
            <ph-button *ngIf="!isGoogleAuthEnabled" (click)="setupGoogleAuth()">Set up authenticator app</ph-button>
        </ph-actions>
    </ph-card>
</ng-template>

<ng-template #smsCard>
    <ph-card heading="Text message" fill>
        <ph-status-badge *ngIf="!isLoading"
                         slot="title-actions"
                         variant="light"
                         [status]="isSmsAuthEnabled ? 'completed' : 'disabled'">{{ isSmsAuthEnabled ? 'Enabled' : 'Not set up' }}</ph-status-badge>

        <ph-skeleton *ngIf="isLoading" lines="2" label="Loading text message authentication"></ph-skeleton>
        <ng-container *ngIf="!isLoading">
            <div *ngIf="isSmsAuthEnabled">Sign-in codes are texted to the phone number ending in {{ smsLast4 }}.</div>
            <div *ngIf="!isSmsAuthEnabled">We text you a 6-digit code each time you sign in.</div>
        </ng-container>

        <ph-actions slot="footer" *ngIf="!isLoading">
            <ph-button *ngIf="isSmsAuthEnabled" variant="secondary" mode="filled" (click)="disableSmsAuth()">Disable text message</ph-button>
            <ph-button *ngIf="!isSmsAuthEnabled" (click)="setupSmsAuth()">Set up text message</ph-button>
        </ph-actions>
    </ph-card>
</ng-template>

<!-- Settings only. Drawn while loading too, so the row never reflows when settings arrive. -->
<ng-template #recoveryCard>
    <ph-card heading="Recovery codes" fill>
        <ph-status-badge *ngIf="!isLoading"
                         slot="title-actions"
                         variant="light"
                         [status]="recoveryCodesBadgeStatus">{{ recoveryCodesStatus }}</ph-status-badge>

        <ph-skeleton *ngIf="isLoading" lines="2" label="Loading recovery codes"></ph-skeleton>
        <div *ngIf="!isLoading">{{ recoveryCodesDescription }}</div>

        <ph-actions slot="footer" *ngIf="!isLoading">
            <ph-button variant="secondary"
                       mode="filled"
                       [disabled]="isRegenerating || !hasTwoFactorMethod"
                       (click)="regenerateRecoveryCodes()">{{ recoveryCodesButtonLabel }}</ph-button>
        </ph-actions>
    </ph-card>
</ng-template>

<app-setup-google-authenticator [open]="isSetupGoogleOpen" (closed)="onSetupGoogleClosed($event)"></app-setup-google-authenticator>
<app-setup-sms-authentication [open]="isSetupSmsOpen" (closed)="onSetupSmsClosed($event)"></app-setup-sms-authentication>
<app-confirm-2fa-code [open]="twoFactorOpen" [data]="twoFactorData" (closed)="onTwoFactorClosed($event)"></app-confirm-2fa-code>
<app-recovery-codes-dialog [open]="recoveryCodesOpen" [codes]="recoveryCodes" (closed)="onRecoveryCodesClosed()"></app-recovery-codes-dialog>
